<template>
    <div :class="{ show: show }" class="notify-modal">
        <div class="notify-modal__header">
            <div v-html="title" class="h3 notify-modal__title"/>
            <button @click.prevent="close()" class="notify-modal__close">
                <svg class="icon"><use xlink:href="/img/front/icons/svgmap.svg#close"></use></svg>
            </button>
        </div>
        <div v-html="text" class="notify-modal__body"/>
        <button v-html="button" @click.prevent="close()" class="btn-outline notify-modal__button"/>
    </div>
</template>

<script>
import helper from "./../mixins/helper";

export default {
    mixins: [
        helper
    ],
    props: {
        title: {
            required: false,
            default: null
        },
        text: {
            required: false,
            default: null
        },
        button: {
            required: false,
            default: null
        }
    },
     data() {
        return {
            show: false
        }
    },
    mounted() {
        this.open();
    },
    methods: {
        open() {
            this.getCookie('techicalworks', (response) => {
                if (response.data.data != 'true') {
                    setTimeout(() => {
                        this.show = true;
                    }, 1000);
                }
            });
        },
        close() {
            this.show = false;
            this.setCookie('techicalworks', 'true', 7);
        }
    }
}
</script>